(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('commentResponse', CommentResponse)

    /** @ngInject */
    function CommentResponse($timeout, AuthenticationService, HelperService, EventService, MediaService, VideoService, NotifyService, PATHS, ROUTES) {
        function CommentResponseController() {
            const vm = this;

            vm.getPersonImage = person => {
                if (person.Image)
                    return `${ROUTES.CENTRAL_CONTAS}api/images/res/100/100/person/${person.ExternalId}/${person.Image}`;

                return `${ROUTES.CENTRAL_CONTAS}api/images/res/100/100/placeholder.jpg`;
            }

            vm.saveComment = () => {
                HelperService.startLoading(`#response${vm.answeringComment ? vm.answeringComment.Id : ''}`);

                let commentData = {
                    Comment: vm.commentText,
                    PersonId: vm.userData.Id
                }

                if (vm.areaId == 1) {
                    commentData.EventId = vm.registerId;

                    if (vm.answeringComment)
                        commentData.EventCommentId = vm.answeringComment.Id;

                    EventService
                        .postComment(commentData)
                        .then(success => successCallback(success, vm.answeringComment), error => errorCallback(error, vm.answeringComment))
                } else if (vm.areaId == 2) {
                    commentData.VideoId = vm.registerId;

                    if (vm.answeringComment)
                        commentData.VideoCommentId = vm.answeringComment.Id;

                    VideoService
                        .postComment(commentData)
                        .then(success => successCallback(success, vm.answeringComment), error => errorCallback(error, vm.answeringComment))
                } else if (vm.areaId == 3) {
                    commentData.NewsId = vm.registerId;

                    if (vm.answeringComment)
                        commentData.NewsCommentId = vm.answeringComment.Id;

                    MediaService
                        .postComment(commentData)
                        .then(success => successCallback(success, vm.answeringComment), error => errorCallback(error, vm.answeringComment))
                }
            }

            init();

            function successCallback(insertCommentSuccess, comment) {
                vm.commentsControl
                    .loadMoreComments(true)
                    .then(() => {
                        $timeout(() => {
                            let parentSubcomment;
                            let lastComment = vm.currentComments.find(x => (x.Id == insertCommentSuccess.Id));

                            // If is events and is a subcomment
                            if (vm.areaId == 1 && insertCommentSuccess.CommentId) {
                                parentSubcomment = vm.currentComments.find(x => (x.Id == insertCommentSuccess.CommentId));
                                lastComment = parentSubcomment.EventComment1.find(x => (x.Id == insertCommentSuccess.Id));
                            }

                            // If is video and is a subcomment
                            else if (vm.areaId == 2 && insertCommentSuccess.VideoCommentId) {
                                parentSubcomment = vm.currentComments.find(x => (x.Id == insertCommentSuccess.VideoCommentId));
                                lastComment = parentSubcomment.VideoComment1.find(x => (x.Id == insertCommentSuccess.Id));
                            }

                            // If is media and is a subcomment
                            else if (vm.areaId == 3 && insertCommentSuccess.NewsCommentId) {
                                parentSubcomment = vm.currentComments.find(x => (x.Id == insertCommentSuccess.NewsCommentId));
                                lastComment = parentSubcomment.NewsComment1.find(x => (x.Id == insertCommentSuccess.Id));
                            }

                            vm.commentText = '';

                            if (parentSubcomment)
                                parentSubcomment.isSubCommentsActive = true;

                            if (lastComment) {
                                lastComment.IsRecentComment = true;

                                $timeout(() => {
                                    lastComment.IsRecentComment = false;
                                }, 10000);
                            }

                            $('html, body').animate({
                                scrollTop: $('#response').offset().top
                            });

                            NotifyService.success('Seu comentário foi criado, aguarde a aprovação para que ele fique visível para todos');
                            HelperService.stopLoading(`#response${comment ? comment.Id : ''}`);
                        })
                    })
            }

            function errorCallback(error, comment) {
                HelperService.errorCallback(error);
                HelperService.stopLoading(`#response${comment ? comment.Id : ''}`);
            }

            function init() {
                vm.userData = AuthenticationService.getUserData();
            }
        }

        return {
            bindToController: true,
            controller: CommentResponseController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/comments/comment-response.html`,
            scope: {
                areaId: '=',
                registerId: '=',
                currentComments: '=',
                commentsControl: '=',
                answeringComment: '='
            }
        }
    }
}());